// import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Lgtransportservicevendor() {


const cardData = {


    keyword: "LG Transport Services Vendor in Pune",

    headingDescription: "LG Transport Services Vendor in Pune by SSK Logistic is structured for businesses looking for organized transportation, logistics, cargo movement, warehousing support, freight handling, and supply chain transportation across Pune and connected industrial regions. SSK Logistic supports vendor-oriented transportation requirements for commercial establishments, manufacturing units, distributors, warehouses, corporate operations, and supply chain teams that need coordinated movement of goods. From truck and container transportation to industrial freight, cargo distribution, warehouse transfers, and recurring business logistics, transportation arrangements can be planned according to shipment size, delivery locations, vehicle requirements, and operational schedules. The service is suitable for businesses seeking a dependable logistics partner for regular and project-based transportation requirements across Pune.",

    topPlaces: [
        {
            title: "Bhosari MIDC",
            description: "Bhosari MIDC is one of Pune's established industrial zones with manufacturing units, engineering companies, suppliers, warehouses, and commercial facilities. SSK Logistic supports transportation vendor requirements in this area for industrial goods, components, machinery, finished products, and regular business consignments."
        },
        {
            title: "Hinjewadi",
            description: "Hinjewadi is a major corporate and technology hub where businesses may require coordinated movement of office equipment, commercial materials, supplies, and distribution consignments. SSK Logistic can support LG-related transportation requirements through planned pickup, vehicle allocation, and delivery coordination."
        },
        {
            title: "Ranjangaon MIDC",
            description: "Ranjangaon MIDC has extensive manufacturing and industrial activity, creating regular requirements for freight movement, raw material transportation, finished goods distribution, and supply chain logistics. SSK Logistic coordinates vendor transportation solutions according to industrial shipment and delivery requirements."
        },
        {
            title: "Talegaon Dabhade",
            description: "Talegaon Dabhade connects important manufacturing, warehousing, and commercial operations around Pune's western industrial belt. Transportation requirements in this region can include machinery, production materials, packaged goods, components, and distribution cargo handled through organized logistics planning."
        },
        {
            title: "Kurkumbh Industrial Area",
            description: "Kurkumbh is associated with industrial and manufacturing activity southeast of Pune and requires structured transportation for different commercial and industrial materials. SSK Logistic supports vendor-based truck, freight, cargo, and industrial logistics requirements for businesses operating in this corridor."
        },
        {
            title: "Kharadi",
            description: "Kharadi is a growing commercial and corporate zone on Pune's eastern side, with offices, warehouses, service businesses, and distribution requirements. SSK Logistic can coordinate corporate and commercial transportation for supplies, equipment, inventory, and business-related consignments."
        },
        {
            title: "Jejuri",
            description: "Jejuri and its surrounding industrial belt are relevant for businesses involved in manufacturing, processing, warehousing, and commercial distribution. SSK Logistic supports transportation planning for goods movement between industrial facilities, warehouses, suppliers, and customer locations."
        },
        {
            title: "Moshi",
            description: "Moshi has developed into an important northern Pune commercial and logistics location with access to industrial areas and distribution networks. Transportation vendor services can be coordinated for commercial inventory, packaged goods, equipment, warehouse transfers, and regular business shipments."
        },
        {
            title: "Pirangut",
            description: "Pirangut is surrounded by manufacturing and industrial establishments that require regular movement of raw materials, machinery, finished products, and commercial supplies. SSK Logistic helps coordinate suitable transportation arrangements based on cargo type, vehicle capacity, and delivery schedules."
        },
        {
            title: "Daund",
            description: "Daund provides an important regional connection for industrial, agricultural, warehousing, and commercial transportation around eastern Pune. SSK Logistic can support business logistics requirements involving bulk cargo, industrial materials, distribution consignments, and recurring transportation movements."
        }
    ],

    "services": [
        {
            "name": "lg transport services vendor pune",
            "description": "SSK Logistic supports businesses searching for lg transport services vendor pune requirements with organized transportation coordination across industrial, commercial, warehouse, and distribution locations. Vehicle planning, pickup scheduling, cargo movement, and destination delivery can be aligned with business logistics requirements."
        },
        {
            "name": "lg transportation vendor pune",
            "description": "The lg transportation vendor pune service is designed for businesses that need coordinated transportation support for regular or project-based movement of goods. SSK Logistic can arrange suitable road transportation according to cargo volume, vehicle requirements, pickup locations, and delivery schedules."
        },
        {
            "name": "lg logistics vendor pune",
            "description": "Businesses requiring an lg logistics vendor pune can coordinate transportation and logistics activities through SSK Logistic for commercial and industrial requirements. The service can cover freight movement, cargo handling coordination, warehouse transfers, distribution routes, and planned goods transportation."
        },
        {
            "name": "lg goods transport vendor pune",
            "description": "The lg goods transport vendor pune service supports movement of commercial products, industrial materials, packaged goods, components, equipment, and business inventory. SSK Logistic coordinates appropriate transportation resources according to the shipment size and destination requirements."
        },
        {
            "name": "lg transport service provider pune",
            "description": "As an lg transport service provider pune, SSK Logistic supports structured road transportation for business consignments moving between warehouses, factories, distribution centers, suppliers, and commercial destinations. Transportation planning can be customized according to operational requirements."
        },
        {
            "name": "lg logistics service provider pune",
            "description": "The lg logistics service provider pune requirement can be supported through coordinated freight, cargo, warehouse transportation, and distribution activities. SSK Logistic helps businesses organize logistics movements with suitable vehicles, route planning, pickup coordination, and destination delivery."
        },
        {
            "name": "lg supply chain vendor pune",
            "description": "SSK Logistic supports the lg supply chain vendor pune requirement for businesses that need transportation assistance within broader supply chain operations. Services can include movement between suppliers, manufacturing facilities, warehouses, distribution points, and customer destinations."
        },
        {
            "name": "lg cargo transportation vendor pune",
            "description": "The lg cargo transportation vendor pune service is suitable for businesses moving commercial and industrial cargo across Pune and connected markets. SSK Logistic coordinates vehicle requirements and transportation schedules for different cargo volumes, packaging conditions, and delivery locations."
        },
        {
            "name": "lg industrial transport vendor pune",
            "description": "Manufacturing and industrial operations requiring an lg industrial transport vendor pune can coordinate transportation of machinery, components, raw materials, equipment, and finished products. SSK Logistic structures industrial transportation around load specifications, vehicle capacity, and delivery requirements."
        },
        {
            "name": "lg commercial transport vendor pune",
            "description": "The lg commercial transport vendor pune service supports retailers, distributors, wholesalers, offices, and commercial establishments requiring regular goods movement. SSK Logistic can coordinate commercial transportation between warehouses, business locations, suppliers, and distribution points."
        },
        {
            "name": "lg freight transport vendor pune",
            "description": "Businesses looking for an lg freight transport vendor pune can use SSK Logistic for organized movement of freight across Pune and interstate business routes. Freight transportation can be planned according to shipment volume, cargo type, vehicle selection, and delivery requirements."
        },
        {
            "name": "lg truck transport vendor pune",
            "description": "The lg truck transport vendor pune service helps businesses arrange suitable trucks for moving commercial and industrial consignments. SSK Logistic coordinates vehicle requirements based on cargo weight, dimensions, quantity, loading conditions, and the final delivery location."
        },
        {
            "name": "lg container transport vendor pune",
            "description": "For businesses handling larger or standardized consignments, the lg container transport vendor pune service provides a structured option for container-based road movement. SSK Logistic coordinates appropriate container vehicles according to cargo characteristics, loading requirements, route conditions, and delivery schedules."
        },
        {
            "name": "lg warehouse transportation vendor pune",
            "description": "The lg warehouse transportation vendor pune service supports movement of inventory between warehouses, factories, distribution centers, and commercial facilities. SSK Logistic helps coordinate scheduled transportation for stock transfers, replenishment movements, finished goods, and warehouse-related cargo."
        },
        {
            "name": "lg distribution transport vendor pune",
            "description": "Businesses requiring an lg distribution transport vendor pune can coordinate delivery movements across multiple commercial and distribution locations. SSK Logistic supports planned vehicle allocation, route coordination, shipment scheduling, and transportation for regular distribution requirements."
        },
        {
            "name": "lg corporate transport vendor pune",
            "description": "The lg corporate transport vendor pune service is focused on business-related transportation requirements involving office equipment, supplies, commercial materials, documents, inventory, and other corporate consignments. SSK Logistic coordinates transportation around organizational schedules and delivery locations."
        },
        {
            "name": "lg authorized transport vendor pune",
            "description": "Businesses searching for an lg authorized transport vendor pune can coordinate their transportation requirements with SSK Logistic for structured goods movement. Vendor transportation arrangements can be planned around shipment specifications, vehicle capacity, pickup schedules, and business delivery requirements."
        },
        {
            "name": "lg logistics partner pune",
            "description": "The lg logistics partner pune service supports businesses seeking ongoing transportation coordination for supply chain and distribution activities. SSK Logistic can assist with recurring freight movement, warehouse transfers, industrial transportation, commercial cargo, and route-based logistics requirements."
        },
        {
            "name": "lg transportation partner pune",
            "description": "An lg transportation partner pune can support businesses with regular road transportation requirements across Pune and connected industrial markets. SSK Logistic coordinates vehicles, pickup points, cargo movement, route planning, and destination delivery according to the client's operational needs."
        },
        {
            "name": "lg goods transportation services pune",
            "description": "The lg goods transportation services pune requirement can be handled through organized road movement for commercial products, industrial materials, equipment, inventory, and packaged consignments. SSK Logistic coordinates transportation according to shipment quantity, vehicle capacity, and destination requirements."
        },
        {
            "name": "lg freight services pune",
            "description": "LG freight services pune are suitable for businesses requiring structured movement of commercial and industrial freight across Pune and other connected locations. SSK Logistic supports freight planning, truck coordination, cargo movement, and delivery scheduling based on business requirements."
        },
        {
            "name": "lg cargo transport services pune",
            "description": "The lg cargo transport services pune service supports businesses moving cargo between manufacturing units, warehouses, suppliers, distributors, and commercial destinations. SSK Logistic coordinates suitable road transportation for different shipment sizes and cargo categories."
        },
        {
            "name": "lg industrial logistics pune",
            "description": "LG industrial logistics pune requirements can include movement of raw materials, machinery, components, production supplies, and finished goods across industrial locations. SSK Logistic supports these movements through planned vehicle allocation, route coordination, loading requirements, and delivery scheduling."
        },
        {
            "name": "lg transportation company pune",
            "description": "SSK Logistic supports the lg transportation company pune requirement with organized road transportation for commercial and industrial businesses. The service can accommodate regular shipments, warehouse transfers, factory deliveries, distribution requirements, and other business-focused transportation activities."
        },
        {
            "name": "lg logistics company pune",
            "description": "Businesses searching for an lg logistics company pune can coordinate transportation and logistics requirements with SSK Logistic for cargo movement, freight transportation, warehouse transfers, industrial distribution, and commercial deliveries. Service planning can be adapted to recurring or individual shipment requirements."
        }
    ],

    "tableData": [
        ["lg transport services vendor pune", "lg transportation vendor pune"],
        ["lg logistics vendor pune", "lg goods transport vendor pune"],
        ["lg transport service provider pune", "lg logistics service provider pune"],
        ["lg supply chain vendor pune", "lg cargo transportation vendor pune"],
        ["lg industrial transport vendor pune", "lg commercial transport vendor pune"],
        ["lg freight transport vendor pune", "lg truck transport vendor pune"],
        ["lg container transport vendor pune", "lg warehouse transportation vendor pune"],
        ["lg distribution transport vendor pune", "lg corporate transport vendor pune"],
        ["lg authorized transport vendor pune", "lg logistics partner pune"],
        ["lg transportation partner pune", "lg goods transportation services pune"],
        ["lg freight services pune", "lg cargo transport services pune"],
        ["lg industrial logistics pune", "lg transportation company pune"],
        ["lg logistics company pune", "LG Transport Services Vendor in Pune"]
    ],

    whychoose: [
        {
            WhyChooseheading: "Business-Focused Transportation Coordination",
            WhyChoosedescription: "SSK Logistic understands that corporate and industrial transportation requires more than simple point-to-point movement. Vehicle planning, pickup schedules, cargo specifications, delivery locations, and recurring shipment requirements can be coordinated around the operating needs of the business."
        },
        {
            WhyChooseheading: "Support for Industrial Supply Chains",
            WhyChoosedescription: "Manufacturing businesses can coordinate transportation for raw materials, machinery, components, production supplies, and finished goods. SSK Logistic structures transportation movements around industrial locations, warehouse connections, and scheduled delivery requirements."
        },
        {
            WhyChooseheading: "Flexible Vehicle Planning",
            WhyChoosedescription: "Cargo volumes and shipment dimensions can vary significantly between business consignments. Transportation arrangements can therefore be planned around suitable truck and container capacities, helping businesses coordinate movement according to the characteristics of each shipment."
        },
        {
            WhyChooseheading: "Warehouse and Distribution Support",
            WhyChoosedescription: "Movement between factories, warehouses, distribution centers, suppliers, and customer locations is an important part of commercial logistics. SSK Logistic coordinates these transportation activities to support inventory transfers, replenishment, distribution, and scheduled goods movement."
        },
        {
            WhyChooseheading: "Recurring Vendor Transportation",
            WhyChoosedescription: "Businesses with regular transportation requirements can coordinate recurring movement through planned vendor arrangements. SSK Logistic can support repeated routes and scheduled shipments while adapting vehicle requirements according to changing cargo volumes and delivery locations."
        },
        {
            WhyChooseheading: "Commercial Cargo Handling",
            WhyChoosedescription: "Retailers, wholesalers, distributors, corporate facilities, and commercial establishments can use transportation arrangements for packaged products, equipment, inventory, supplies, and other business cargo. Each movement can be organized around the shipment's practical transportation requirements."
        },
        {
            WhyChooseheading: "Pune Industrial Network Coverage",
            WhyChoosedescription: "Transportation requirements can arise across established and developing industrial locations such as Bhosari, Ranjangaon, Talegaon, Pirangut, Kurkumbh, and other Pune-region business zones. SSK Logistic coordinates road transportation according to pickup and destination requirements across these areas."
        },
        {
            WhyChooseheading: "Structured Logistics Partnership",
            WhyChoosedescription: "A transportation partner needs to coordinate multiple stages of goods movement with clarity. SSK Logistic supports businesses through vehicle planning, freight coordination, pickup scheduling, route management, and delivery planning for individual as well as recurring logistics requirements."
        }
    ]

};
















const faqData = [
    {
        question: "What does SSK Logistic offer as an LG transport services vendor in Pune?",
        answer: "SSK Logistic supports LG-related commercial transportation requirements in Pune by coordinating suitable goods movement according to cargo type, shipment quantity, pickup location, delivery destination, vehicle capacity, loading requirements, and business schedules."
    },
    {
        question: "Can SSK Logistic handle LG product transportation in Pune?",
        answer: "Suitable LG products, commercial inventory, equipment, packaged goods, components, and other approved business consignments can be considered for transportation based on their quantity, dimensions, weight, handling requirements, and destination."
    },
    {
        question: "Can LG-related goods be transported from Pune to other cities?",
        answer: "Intercity and interstate transportation can be discussed for LG-related commercial shipments moving from Pune to destinations across Maharashtra and other parts of India, depending on the cargo and vehicle requirements."
    },
    {
        question: "Does SSK Logistic support regular transportation requirements for LG businesses?",
        answer: "Companies with recurring movement requirements can discuss regular transportation arrangements based on shipment frequency, cargo volume, pickup points, delivery locations, vehicle capacity, and their operational schedule."
    },
    {
        question: "Which Pune areas can be covered for LG transport requirements?",
        answer: "Pickup and delivery arrangements can be discussed across commercial and industrial areas of Pune, including Pimpri-Chinchwad, Bhosari, Chakan, Talegaon, Hinjewadi, Hadapsar, Ranjangaon, and other suitable business locations."
    },
    {
        question: "What type of vehicle can be arranged for LG product transportation?",
        answer: "Vehicle selection depends on the product quantity, cargo weight, dimensions, packaging, loading conditions, and delivery requirements. SSK Logistic can discuss appropriate commercial vehicle options after reviewing the shipment details."
    },
    {
        question: "Can SSK Logistic coordinate warehouse-to-distribution transportation for LG goods?",
        answer: "Warehouse-to-distribution movement can be coordinated for suitable commercial shipments between storage facilities, distribution centers, dealers, business locations, and other approved delivery points according to the required transportation plan."
    },
    {
        question: "Can bulk LG shipments be transported through SSK Logistic?",
        answer: "Bulk shipment requirements can be discussed by providing the total product quantity, approximate weight, number of consignments, loading location, delivery destination, vehicle requirement, and preferred movement schedule."
    },
    {
        question: "How does SSK Logistic plan LG transport services in Pune?",
        answer: "Transportation planning considers the exact pickup and delivery locations, product type, shipment quantity, weight and dimensions, packaging and loading requirements, vehicle capacity, route needs, and expected delivery timeline."
    },
    {
        question: "What information is required to enquire about LG transport services in Pune?",
        answer: "Businesses can share the pickup location, delivery address, product or cargo details, approximate quantity and weight, dimensions if applicable, loading requirements, vehicle preference, shipment frequency, and preferred transportation schedule."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Manish Tiwari",
        feedback: "Our business required regular movement of LG-related commercial products from a Pune warehouse to different delivery points. SSK Logistic understood our transportation requirements and helped coordinate the shipments according to our operating schedule.",
        rating: 5
    },
    {
        id: 2,
        name: "Miss. Komal Deshpande",
        feedback: "We needed transportation support for packaged LG inventory from our Pune facility. The SSK Logistic team discussed the cargo quantity, loading details, and vehicle requirements clearly, which made the logistics coordination much more convenient.",
        rating: 5
    }
];






    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Logistics Company Pune",
            link: "Logistics-Company-Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Best Logistics Companies in Pune",
            link: "Best-Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Top Logistics Companies in Pune",
            link: "Top-Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Logistics in Pune",
            link: "Logistics-in-Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Transport Company in Pune",
            link: "Transport-Company-in-Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Logistics Companies in Pune",
            link: "Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Transporters in Pune",
            link: "Transporters-in-Pune",
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Transport Office",
            link: "Pune-Transport-Office",
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Best Logistics Company in Pune",
            link: "Best-Logistics-Company-in-Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Goods Transport Services in Pune",
            link: "Goods-Transport-Services-in-Pune",
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Transportation Services for Industrial",
            link: "Transportation-Services-for-Industrial",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune Transport Service for Company",
            link: "Pune-Transport-Service-for-Company",
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Industrial Transport Company in Pune",
            link: "Industrial-Transport-Company-in-Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Supply Chain Management Company in Pune",
            link: "Supply-Chain-Management-Company-in-Pune",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Cargo Transportation Company in Pune",
            link: "Cargo-Transportation-Company-in-Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Commercial Transportation Services in Pune",
            link: "Commercial-Transportation-Services-in-Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Container Transportation Company in Pune",
            link: "Container-Transportation-Company-in-Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Third Party Logistics Company in India",
            link: "Third-Party-Logistics-Company-in-India",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Transport Service",
            link: "Pune-to-Mumbai-Transport-Service",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune to Bangalore Transport Service",
            link: "Pune-to-Bangalore-Transport-Service",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Hyderabad Transport Service",
            link: "Pune-to-Hyderabad-Transport-Service",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Chennai Transport Service",
            link: "Pune-to-Chennai-Transport-Service",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Delhi Transport Service",
            link: "Pune-to-Delhi-Transport-Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Ahmedabad Transport Service",
            link: "Pune-to-Ahmedabad-Transport-Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Surat Transport Service",
            link: "Pune-to-Surat-Transport-Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Nashik Transport Service",
            link: "Pune-to-Nashik-Transport-Service",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Nagpur Transport Service",
            link: "Pune-to-Nagpur-Transport-Service",
        },
        {
            place: "/images/keyword/28.jpg",
            text: "Pune to Kolhapur Transport Service",
            link: "Pune-to-Kolhapur-Transport-Service",
        },
    ];















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "LG Transport Services Vendor in Pune",
  "image": "https://ssklogistics.in/assets/images/lg-transport-services-vendor-in-pune.webp",
  "description": "SSK Logistics provides LG Transport Services Vendor in Pune solutions for businesses and supply chain operations requiring organized transportation, logistics, goods movement and cargo handling support. LG transportation vendor Pune requirements can be coordinated for commercial shipments, industrial consignments, warehouse transfers, distribution movements and regular business transportation needs. LG logistics vendor Pune services can support structured movement of goods between suppliers, warehouses, manufacturing locations, distribution centers and customer destinations. LG goods transport vendor Pune solutions can be arranged according to shipment volume, cargo type, vehicle capacity, pickup requirements and delivery schedules. As an LG transport service provider Pune businesses can coordinate suitable road transportation arrangements for recurring and project-based requirements. LG logistics service provider Pune requirements can include transportation planning, vehicle coordination, route scheduling, shipment movement and delivery coordination. LG supply chain vendor Pune services can support businesses that require dependable transportation assistance as part of their wider procurement, warehousing and distribution operations. LG cargo transportation Pune requirements can cover commercial cargo, packaged products, equipment, inventory, industrial materials and other suitable consignments. SSK Logistics can coordinate dedicated vehicles, full truck load transportation and other road-based logistics solutions based on shipment specifications and operational schedules. The service is designed to support organized goods movement across Pune and surrounding industrial, commercial and warehouse locations while maintaining practical coordination between pickup and delivery points. Businesses seeking an LG transport vendor in Pune can use flexible transportation arrangements aligned with cargo requirements, delivery timelines and ongoing supply chain activities.",
  "brand": {
    "@type": "Brand",
    "name": "SSK Logistics"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Contact for Logistics Service Pricing",
    "availability": "https://schema.org/InStock",
    "url": "https://ssklogistics.in/lg-transport-services-vendor-in-pune"
  }
};

    return (
        <div>

<Helmet>
  <title>
    LG Transport Services Vendor in Pune | Logistics, Goods & Supply Chain Transportation | +91 9876543210
  </title>

  <meta
    name="description"
    content="SSK Logistics supports LG transport services vendor requirements in Pune with coordinated transportation, goods movement, cargo logistics and supply chain transportation solutions."
  />

  <meta
    name="keywords"
    content="LG Transport Services Vendor in Pune, LG transport services vendor Pune, LG transportation vendor Pune, LG logistics vendor Pune, LG goods transport vendor Pune, LG transport service provider Pune, LG logistics service provider Pune, LG supply chain vendor Pune, LG cargo transportation Pune, LG cargo transport vendor Pune, LG transportation services Pune, LG logistics services Pune, LG goods transportation Pune, LG goods transport services Pune, LG freight transport Pune, LG freight services Pune, LG cargo logistics Pune, LG supply chain services Pune, LG supply chain transportation Pune, LG warehouse transport Pune, LG distribution transport Pune, LG commercial transport vendor Pune, LG industrial transport vendor Pune, LG transport company Pune, LG logistics company Pune, LG goods transport company Pune, LG cargo transport company Pune, LG dedicated truck transport Pune, LG full truck load transport Pune, LG FTL transport Pune, LG road transport vendor Pune, LG business transportation Pune, LG commercial goods transportation Pune, LG industrial goods transportation Pune, LG warehouse logistics Pune, LG distribution logistics Pune, LG third party logistics vendor Pune, LG supply chain logistics vendor Pune, LG transportation service provider Pune, LG logistics service provider in Pune, LG goods transport service provider Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>








            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/36.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >SSK Logistics
                                : {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="cab-service-list">
                                {cardData.services.map((service, index) => (
                                    <div className="cab-service-row" key={index}>
                                        <div className="cab-service-details">
                                            <h4>{service.name}</h4>
                                            <span className="cab-service-line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="cab-service-arrow">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div> */}
                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>


                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>SSK Logistics</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">




                                        <div className="row twm-faq-section-1 m-b30">


                                            <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                                <div className="twm-faq-info-wrap">

                                                    <div className="section-head left">
                                                        <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For SSK Logistics </h2>
                                                    </div>


                                                    <div className="twm-faq-info">
                                                        <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                            <FaqSection
                                                                title=""
                                                                subtitle=""
                                                                items={faqData}
                                                            />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919876543210 " className="pc-call">+91 9876543210 </a>
                                        </div>


                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919876543210 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919876543210 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:info@ssklogistics.in" className="pc-email">
                                            info@ssklogistics.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>SSK Logistics</strong><br />
                                            ViOffice no. 109 first Floor, Ashoka Plaza, above dominos Pizza, Beside Hyatt Hotel, Viman Nagar, Pune- 411014




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Lgtransportservicevendor;